"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverStoryCategory = void 0;
exports.DriverStoryCategory = {
    ADD_DRIVER_COMMENT: 'ADD_DRIVER_COMMENT',
    ACCOUNT_STATE_UPDATE: 'ACCOUNT_STATE_UPDATE',
    DRIVER_DATA_UPDATE: 'DRIVER_DATA_UPDATE',
    VEHICULE_DATA_UPDATE: 'VEHICULE_DATA_UPDATE',
};
